// extracted by mini-css-extract-plugin
export default {"backDrop":"styles_backDrop__rPZyb","appear":"styles_appear__6Bv8-"};